import {Directive, ElementRef} from '@angular/core';
import {FoodPortalStateService} from '../services/food-portal-state.service';

@Directive({
    selector: '[piKeyColorBackground]',
    standalone: false
})
export class KeyColorBackgroundDirective {

  constructor(private el: ElementRef, private stateService: FoodPortalStateService) {
    this.el.nativeElement.style.backgroundColor = this.stateService.portalSettings.keyColour;
  }

}
